import { Component, ChangeDetectorRef } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportService } from "../../services/report.service";
import { ApiService } from "../../services/api.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { FileService } from "../../services/file.service";

@Component({
  selector: 'page-report-files',
  templateUrl: 'report-files.html',
})
export class ReportFilesPage {

  public unitId = 0;
  public unitVersionId = 0;
  public country = 'NL';
  public enabled = false;
  public showFooter = false;

  public data: any;
  public files: any = [];
  public unitVersionFiles: any = [];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public modalCtrl: ModalController,
      public changeDetector: ChangeDetectorRef,
      public superTabsCtrl: SuperTabsController,
      public reportService: ReportService,
      public alertCtrl: AlertController,
      public apiService: ApiService,
      public fileService: FileService,
      public iab: InAppBrowser
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.files) this.data.files = [];
    this.files = this.data.files;
    if(!this.data.location.units) this.data.location.units = [];
    if(this.data._selected_unit){
      this.enabled = true;
      this.unitVersionId = this.data._selected_unit.unit_version_id;
      this.unitId = this.data._selected_unit.unit_id;
    } else {
      this.enabled = false;
      this.unitVersionId = 0;
      this.unitId = 0;
    }
    this.country = (this.data.customers && this.data.customers.client && this.data.customers.client.country ? this.data.customers.client.country : 'NL');
    if(this.unitVersionId){
      this.apiService.getUnitVersionFiles(this.unitVersionId, this.unitId, this.country).then((data) => {
        this.unitVersionFiles = data;
      }).catch(() => {
        // TODO
      });
    }
  }

  ionViewDidEnter() {
    console.log('ReportFilesPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportFilesPage: ionViewDidLeave');
    if(this.data._selected_unit){
      this.superTabsCtrl.setColor('reportFilesPage', 'tab_ok', 'mainTabs');
    } else {
      this.superTabsCtrl.setColor('reportFilesPage', 'tab_error', 'mainTabs');
    }
    this.save();
  }

  addFile(){
    this.fileService.getFile().then((file: any) => {
      file.list_title = file.filename;
      file.list_subtitle = 'Zojuist toegevoegd';
      file.url = file.src;
      this.files.push(file);
      this.uploadFiles();
    }).catch((error) => {
      this.changeDetector.detectChanges();
      if(error == -1){
        this.alertCtrl.create({
          title: 'Bestand te groot',
          message: 'Dit bestand is te groot. Het bestand mag maximaal ' + this.fileService.maxFileSizeMegaBytes + 'MB groot zijn',
          buttons: ['OK']
        }).present();
      }
    });
  }

  viewFile(file){
    if(file.url){
      this.iab.create(file.url, '_system');
    }
  }

  removeFile(index){
    this.alertCtrl.create({
      title: 'Bestand verwijderen',
      message: 'Weet u zeker dat u dit bestand wilt verwijderen?',
      buttons: [
        {
          text: 'Nee',
          role: 'cancel'
        },
        {
          text: 'Ja',
          handler: () => {
            this.files.splice(index, 1);
          }
        }
      ]
    }).present();
  }

  save(){
    this.data.files = this.files;
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      if (this.data._show_all_tabs) {
        this.superTabsCtrl.slideTo('reportMeasurementPage', 'mainTabs');
      } else {
        this.superTabsCtrl.slideTo('reportSubmitPage', 'mainTabs');
      }
    });
  }

  uploadFiles() {
    for (let file of this.files) {
      if (!file.file_id) {
        this.apiService.uploadFile(file.src, file.filename).then((data: any) => {
          file.file_id = data.file_id;
          file.token = data.token;
          file.src = data.display_url;
          file.url = data.display_url;
          file._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-files/report-files.ts